/**
 * Device ID Management
 * Stores device ID in cookie for persistence across sessions
 */

import { generateGuid } from './crypto'

// Cookie name from legacy application
const DEVICE_ID_COOKIE = 'kLh2jeKJ67G'

/**
 * Get or create device ID
 * Persisted in cookie with 10-year expiry
 *
 * @returns Device ID (UUID format)
 */
export function getOrCreateDeviceId(): string {
    let deviceId = getCookie(DEVICE_ID_COOKIE)

    if (!deviceId) {
        deviceId = generateGuid()
        setCookie(DEVICE_ID_COOKIE, deviceId, { expires: 3650 })  // 10 years
    }

    return deviceId
}

/**
 * Get cookie value by name
 */
function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))
    return match ? (match[2] || null) : null
}

/**
 * Set cookie with expiration
 */
function setCookie(name: string, value: string, options: { expires: number }): void {
    const date = new Date()
    date.setDate(date.getDate() + options.expires)
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`
}

/**
 * Clear device ID (for testing)
 */
export function clearDeviceId(): void {
    document.cookie = `${DEVICE_ID_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
}
